module.exports = __webpack_public_path__ + "img/ph_manange2.6958c2ee.png";